import React from 'react';
import { Redirect } from "react-router-dom";
import store from '../store/store';

export default ({ to }) => {
  const filterString = store.getState().filters[to];
  return <Redirect to={`/${to}${filterString ? '?' + filterString : ''}`} />
}



// WEBPACK FOOTER //
// ./src/component/RedirectWithFilters.js